import Stack from '@mui/material/Stack';
import { alpha, type Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { Pill } from '../Pill.js';

export const CARD_SX = {
  p: 4,
  borderRadius: 2,
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
  minWidth: 0,
};
export const TILE_SX = { ...CARD_SX, gap: 2, p: 3 };
export const GRID_SX = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    sm: 'repeat(2, minmax(0, 1fr))',
    md: 'repeat(2, minmax(0, 1fr))',
  },
  gap: 2,
};
export const EYEBROW_SX = {
  fontSize: 10,
  fontWeight: 600,
  textTransform: 'uppercase',
  color: 'text.disabled',
};
export const ONE_LINE = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};
export const SUCCESS_PILL_SX = (theme: Theme) => ({
  bgcolor: alpha(theme.palette.success.dark, 0.1),
  color: theme.palette.success.dark,
});

export function Copy({ label, children }: { label: string; children: ReactNode }): ReactNode {
  if (!children) return null;
  return (
    <Stack sx={{ gap: 0.5, minWidth: 0 }}>
      <Typography sx={EYEBROW_SX}>{label}</Typography>
      <Typography
        component="div"
        sx={{ fontSize: 12, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', textWrap: 'pretty' }}
      >
        {children}
      </Typography>
    </Stack>
  );
}

export function Chips({ values }: { values: string[] }): ReactNode {
  const unique = [...new Set(values.filter((value) => value !== ''))];
  if (unique.length === 0) return null;
  return (
    <Stack direction="row" sx={{ gap: 1, flexWrap: 'wrap' }}>
      {unique.map((value) => (
        <Pill key={value} sx={{ color: 'text.primary' }}>
          {value}
        </Pill>
      ))}
    </Stack>
  );
}

export function selectionSummary(selected: number, total: number): string {
  return selected === total ? `All ${total} selected` : `${selected} of ${total} selected`;
}
